export default __webpack_public_path__ + "static/media/circle1.1b8ecd8f.svg";